import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import CompanyCategoryManager from "../../../../components/categories2/CompanyCategoryManager";
import CompanyTargetCategoryManager from "../../../../components/categories2/CompanyTargetCategoryManager";
import CompanyDescriptionViewEdit from "../../../../components/company-service/companies/CompanyDescriptionViewEdit";
import CompanyImageSummary from "../../../../components/company-service/companies/CompanyImageSummary";
import CompanyPostSummary from "../../../../components/company-service/companies/CompanyPostSummary";
import CompanyProfileCompletion from '../../../../components/company-service/companies2/CompanyProfileCompletion';
import MtzTodoMessages from '../../../../components/company-service/companies2/MtzTodoMessages';
import CompanyGroupDisplaySummary from "../../../../components/network-service/companyGroups/CompanyGroupDisplaySummary";
import ProductMenuManager from "../../../../components/productMenus/ProductMenuManager";
import CompanyProfileTour from "../../../../components/productTours/CompanyProfileTour";
import QuickGuideFloatingButton from "../../../../components/productTours/QuickGuideFloatingButton";
import WithThreeColumnLayout from "../../../../layouts/WithThreeColumnLayout";

import mtzApis from "../../../../services";
import LogoBanner from "./LogoBanner";

import CompanyTagManager from "../../../../components/company-service/companyTags/CompanyTagManager";

import AuthContext from "../../../../AuthContext";
import PlanUpsell from '../../../../components/shared2/PlanUpsell';
import CompanyFromQRDialog from "./CompanyFromQRDialog";

const { companyService } = mtzApis;

function CompanyDetailPage(props) {
  let [company, setCompany] = React.useState(null);
  const me = React.useContext(AuthContext);
  let [fromQR, setFromQR] = React.useState(false);
  let profileName = props.match.params.profileName;

  React.useEffect(() => {
    (async () => {
      // not owner, then ony see completed profile 100%
      if (profileName) {
        let companies = await companyService.getCompanies(
          new URLSearchParams(`profileName=${profileName}&isViewCounted=${true}&isLogged=${true}`)
        );
        company = companies[0];
      }
      setCompany(company);

      // Check for 'fromQR' attribute and open the dialog
      const urlSearchParams = new URLSearchParams(window.location.search);
      if (urlSearchParams.get('fromQR') == 'true') {
        fromQR = true;
        setFromQR(fromQR);
      }
    })();
  }, [props.match.params.profileName]);

  const handleCloseDialog = () => {
    setFromQR(false);
  };

  if (company === null)
    return 'Loading...';

  return (
    <div className="d-flex flex-column w-100 mtz-gap-16">
      {
        fromQR &&
        <CompanyFromQRDialog profileName={profileName} handleClose={handleCloseDialog} />
      }

      {
        company && company.profilePercent !== 1 &&
        <CompanyProfileCompletion />
      }

      <LogoBanner profileName={profileName} />

      {
        !me.userId &&
        <h5 className="text-center my-4">
          <NavLink className='text-danger' to={`/login?redirectUrl=${window.location.pathname}`}>
            You are not logged in. Some details require a login to see.
          </NavLink>
        </h5>
      }

      <CompanyDescriptionViewEdit profileName={profileName} />

      {
        !!me.userId &&
        <>
          <CompanyCategoryManager profileName={profileName} />

          <CompanyTargetCategoryManager profileName={profileName} />

          <CompanyTagManager profileName={profileName} />

          <ProductMenuManager profileName={profileName} />

          <CompanyPostSummary company={company} />

          <CompanyGroupDisplaySummary profileName={profileName} />

          <QuickGuideFloatingButton component={CompanyProfileTour} />
        </>
      }
    </div>
  );
}

function Sidebar(props) {

  return (
    <div className="d-flex flex-column mtz-gap-16 w-100">
      <CompanyImageSummary profileName={props.match.params.profileName} />
    </div>
  );
}

const Content = withRouter(CompanyDetailPage);

const Wrapper = () => {
  const me = React.useContext(AuthContext);

  return <WithThreeColumnLayout left={() => <></>} center={Content} right={() =>
  (
    <div className="d-flex flex-column mtz-gap-16">
      <MtzTodoMessages />
      <PlanUpsell />
    </div>
  )}
  />;
}

export default Wrapper;
